<div>
  @for (statsItem of queryItem; track statsItem; let i = $index) {
    @if (i === 0) {
      <div>
        <atlas-stats-item
          [iconName]="statsItem.iconName"
          [value]="statsItem.value"
          [name]="statsItem.name"
          [isMainStats]="true"
          >
        </atlas-stats-item>
      </div>
    }
  }
  <div class="secondary-stats-panel">
    @for (statsItem of queryItem; track statsItem; let i = $index) {
      @if (i > 0) {
        <div>
          <atlas-stats-item
            [iconName]="statsItem.iconName"
            [value]="statsItem.value"
            [name]="statsItem.name"
            [isMainStats]="false"
            [isOddIndex]="i % 2 === 1"
            >
          </atlas-stats-item>
        </div>
      }
    }
  </div>
</div>
